import React from 'react';

import _ from 'lodash';
import { compose } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import WithUser from 'shared/HOCs/WithUser';

import Button from 'shared/components/Button';
import { openModal } from 'shared/components/Modals/reducer';

import { toggleConnection } from './ducks';

import styles from './styles.module.scss';

class ConnectButton extends React.Component {
  componentDidMount() {
    if (_.isNil(this.props.connected)) {
      console.warn(
        "ConnectButton has not been supplied with 'connected' prop which is used as an initial value."
      );
    }
  }

  state = {
    connected: this.props.connected // we use it as an initial value
  };

  handleClick = () => {
    const { user, influencer, openModal, toggleConnection } = this.props;

    if (_.isNil(user)) {
      return openModal({ modalName: MODALS.SIGNUP });
    }

    const extra = [this.setConnected];

    toggleConnection({ userToConnectId: influencer.id, extra });
  };

  setConnected = ({ connected }) => this.setState({ connected });

  render() {
    const { connected } = this.state;
    const {
      user,
      influencer,
      className,
      disabled,
      isPerformingConnectOperation
    } = this.props;

    const isSameUser = _.get(user, 'id', -1) === influencer.id;

    return (
      <Button
        color={connected ? 'dark' : 'orange-gradient'}
        onClick={this.handleClick}
        disabled={isPerformingConnectOperation || isSameUser || disabled}
        className={classNames(className, styles.button)}>
        {connected ? 'Connected' : 'Connect'}
      </Button>
    );
  }
}

const mapStateToProps = state => {
  const { isPerformingConnectOperation } = state.shared.connectButton;

  return { isPerformingConnectOperation };
};

const mapDispatchToProps = {
  openModal,
  toggleConnection
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  WithUser
)(ConnectButton);
